import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"
import { reportJsFailure } from "../shared/js_error_banner"

export default class extends Controller {
  static targets = ["select", "code", "description"]

  connect() {
    try {
      this.choices = new Choices(this.selectTarget, {
        searchEnabled: true,
        searchChoices: false,
        itemSelectText: "",
        placeholder: true,
        placeholderValue: "Start typing to search…",
        searchFloor: 2,
        shouldSort: false,
        noChoicesText: "Type to search…",
      })
    } catch (e) {
      reportJsFailure("A search field on this page failed to load. Please refresh the page.", e)
      return
    }

    // Listen on the input Choices.js renders, not the original select
    const searchInput = this.element.querySelector(".choices__input--cloned")
    if (searchInput) {
      searchInput.addEventListener("input", this.onInput.bind(this))
    }

    this.selectTarget.addEventListener("change", this.onChange.bind(this))
    this.debounce = null
  }

  disconnect() {
    this.choices?.destroy()
  }

  onInput(event) {
    clearTimeout(this.debounce)
    const q = event.target.value.trim()
    if (q.length < 2) {
      this.choices.clearChoices()
      return
    }
    this.debounce = setTimeout(() => this.fetchChoices(q), 250)
  }

  async fetchChoices(q) {
    const url = `${this.element.dataset.searchUrl}?q=${encodeURIComponent(q)}`
    const response = await fetch(url, { headers: { Accept: "application/json" } })
    const results = await response.json()
    this.choices.setChoices(
      results.map(({ code, description }) => ({
        value: code,
        label: `${code} — ${description}`,
        customProperties: { description },
      })),
      "value",
      "label",
      true
    )
  }

  onChange() {
    const selected = this.choices.getValue()
    if (!selected?.value) return

    this.codeTarget.value = selected.value
    this.descriptionTarget.value = selected.customProperties?.description ?? ""

    const submit = this.element.closest("form")?.querySelector("[data-icd-choices-submit]")
    if (submit) submit.disabled = false
  }
}
